const BASE_ACTION_TYPE = 'LANDLORD::EVENT';

export const CREATE_EVENT = `${BASE_ACTION_TYPE}::CREATE_EVENT`;
export const EDIT_EVENT = `${BASE_ACTION_TYPE}::EDIT_EVENT`;
export const DELETE_EVENT = `${BASE_ACTION_TYPE}::DELETE_EVENT`;
export const FETCH_EVENT = `${BASE_ACTION_TYPE}::FETCH_EVENT`;
